// A topic's visible/cacheable state belongs to both a principal and a topic.
// Delayed responses from an earlier scope must never populate the new one.
export function scopedMessages(state, scope) {
  return state.scope === scope ? state.rows : []
}
export function updateScopedMessages(state, scope, update) {
  if (state.scope !== scope) return state
  const rows = typeof update === 'function' ? update(state.rows) : update
  return rows === state.rows ? state : { scope, rows }
}
